<div *ngIf="label" class="d-flex align-items-center justify-content-between py-2 border-bottom policy-field-row">
  <div class="d-flex align-items-center">
    <label class="form-label small fw-medium mb-0">{{ label }}</label>
    <i *ngIf="helpText" class="bi bi-info-circle text-muted ms-2" [ngbTooltip]="helpText" container="body"></i>
  </div>
  <div class="btn-group" role="group">
    <button type="button" class="btn policy-toggle-btn" [ngClass]="value ? 'btn-secondary' : 'btn-danger'" [disabled]="disabled" (click)="set(false)">No</button>
    <button type="button" class="btn policy-toggle-btn" [ngClass]="value ? 'btn-success' : 'btn-secondary'" [disabled]="disabled" (click)="set(true)">Yes</button>
  </div>
</div>

<div *ngIf="!label" class="btn-group" role="group">
  <button type="button" class="btn policy-toggle-btn" [ngClass]="value ? 'btn-secondary' : 'btn-danger'" [disabled]="disabled" (click)="set(false)">No</button>
  <button type="button" class="btn policy-toggle-btn" [ngClass]="value ? 'btn-success' : 'btn-secondary'" [disabled]="disabled" (click)="set(true)">Yes</button>
</div>
